import { compose, setDisplayName } from 'react-recompose';
import { formValueSelector } from 'redux-form/immutable.js';

import { getOrganizatioTypesByItem } from '~/state/ducks/app/selectors.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import PortalForm from '../components/PortalForm.jsx';

export default compose(
    setDisplayName('PortalFormContainer'),
    withReduxConnect({
        mapStateToProps: (state, { form }) => ({
            isPortal: formValueSelector(form)(state, 'portal'),
            organizatioTypesByItem: getOrganizatioTypesByItem(state),
            licenses: formValueSelector(form)(state, 'licenses'),
        }),
    }),
)(PortalForm);
